import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PaymentMethods.module.scss';

const PaymentMethods: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.paymentMethods}>
      <OpText variant="body" size="small" className={styles.secure}>
        {t('txt_100_secured_payment')}
      </OpText>
      <div className={styles.providers}>
        <div>icon 1</div>
        <div>icon 2</div>
        <div>icon 3</div>
        <div>icon 4</div>
        <div>icon 5</div>
      </div>
    </div>
  );
};

export default PaymentMethods;
